module.exports = __webpack_public_path__ + "img/buessiness_zotl_h1.59355d84.png";